module.exports = __webpack_public_path__ + "static/media/Ellipsis-1s-200px.d1cc1024.svg";